import MyAccountHeader from './MyAccountHeader';
import { MyAccountHeaderProps, MyAccountHeaderValueProps } from './types';

export type { MyAccountHeaderProps, MyAccountHeaderValueProps };
export default MyAccountHeader;
